/*
  Terms of Service gate: product page (stones), cart page and cart drawer.

  Cart page / drawer: the checkbox is a real required input tied to the cart form, so the browser blocks
  checkout until it is ticked. Product page: the product form has novalidate, so this script blocks
  Add to cart itself, and the Shop Pay / dynamic checkout buttons ship locked (inert) until the box is ticked.

  Extras: dims the buttons, shows the inline message, keeps every box on the page in step, and saves the answer
  to the cart (attribute "Agreed to Terms of Service") so it survives drawer re-renders and pre-ticks the cart box.
  On product pages the box also travels with the line item as the private property
  "_Agreed to Terms of Service", so the order records which stone it was agreed for.
*/
(function () {
  if (window.__dbkTermsGate) return;
  window.__dbkTermsGate = true;

  var ATTR = 'Agreed to Terms of Service';
  var MESSAGE = 'Please agree to the Terms of Service to continue.';
  var SCOPE = '.cart__blocks, .drawer__footer, .product-form';

  function reveal(input) {
    var block = input.closest('[data-dbk-terms]');
    if (!block) return;
    block.classList.add('is-invalid');
    var message = block.querySelector('[data-dbk-terms-error]');
    if (message) message.hidden = false;
  }

  function sync() {
    var blocks = document.querySelectorAll('[data-dbk-terms]');
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      var input = block.querySelector('[data-dbk-terms-input]');
      if (!input) continue;
      var agreed = input.checked;
      input.setCustomValidity(agreed ? '' : MESSAGE);

      var scope = block.closest(SCOPE) || block.parentElement;

      var checkout = scope.querySelectorAll('.cart__checkout-button');
      for (var b = 0; b < checkout.length; b++) checkout[b].classList.toggle('dbk-gated', !agreed);

      var submits = scope.querySelectorAll('.product-form__submit');
      for (var s = 0; s < submits.length; s++) {
        var submit = submits[s];
        if (submit.disabled) continue; // sold out: leave it alone
        submit.classList.toggle('dbk-gated', !agreed);
        if (!agreed) submit.setAttribute('aria-disabled', 'true');
        else if (!submit.classList.contains('loading')) submit.removeAttribute('aria-disabled');
      }

      var locks = scope.querySelectorAll('[data-dbk-terms-lock], .additional-checkout-buttons');
      for (var d = 0; d < locks.length; d++) {
        if (agreed) locks[d].removeAttribute('inert');
        else locks[d].setAttribute('inert', '');
      }
    }
  }

  function save(agreed) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var attributes = {};
    attributes[ATTR] = agreed ? 'Yes' : '';
    try {
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      }).catch(function () {});
    } catch (e) {}
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches('[data-dbk-terms-input]')) return;

    var all = document.querySelectorAll('[data-dbk-terms-input]');
    for (var i = 0; i < all.length; i++) {
      all[i].checked = target.checked;
      var block = all[i].closest('[data-dbk-terms]');
      if (block) {
        block.classList.remove('is-invalid');
        var message = block.querySelector('[data-dbk-terms-error]');
        if (message) message.hidden = true;
      }
    }
    sync();
    save(target.checked);
  });

  // Cart page / drawer: the browser's own validation fires 'invalid' (it does not bubble, so capture it).
  document.addEventListener(
    'invalid',
    function (event) {
      var target = event.target;
      if (!target || !target.matches || !target.matches('[data-dbk-terms-input]')) return;
      reveal(target);
    },
    true
  );

  // Product page: clicking a locked Add to cart explains why and takes the customer to the box.
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      var button = target && target.closest ? target.closest('.product-form__submit.dbk-gated') : null;
      if (!button) return;
      var scope = button.closest('.product-form');
      var input = scope && scope.querySelector('[data-dbk-terms-input]');
      if (!input || input.checked) return;
      event.preventDefault();
      reveal(input);
      input.focus();
    },
    true
  );

  // Product page: Enter inside the form must not slip past the gate either.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      var input = form && form.querySelector ? form.querySelector('[data-dbk-terms-input]') : null;
      if (!input || input.checked) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      reveal(input);
    },
    true
  );

  // The drawer is re-rendered after adds and quantity changes, so re-apply state whenever the DOM changes.
  var queued = false;
  function queueSync() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      sync();
    });
  }
  new MutationObserver(queueSync).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();